module.exports = __webpack_public_path__ + "img/promo-individuelles@2x.8b67f712.png";